/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'Poproś zespół lub administratora o wsparcie.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': 'Nie można pobrać żadnych wyników dla tego wyszukiwania'
};